const createRecord = <K extends string | number, V>(keys: ReadonlyArray<K>, value: V) =>
  keys.reduce((map, key) => {
    map[key] = value;
    return map;
  }, {} as { [P in K]: V });

export default createRecord;
